var StoreAction;
(function (StoreAction) {
    StoreAction[StoreAction["UPDATE_NAMED_VALUE"] = 0] = "UPDATE_NAMED_VALUE";
    StoreAction[StoreAction["INTERACT_SET_ALL_FROM_LIST"] = 1] = "INTERACT_SET_ALL_FROM_LIST";
    StoreAction[StoreAction["INTERACT_SET_ALL_FOR_TYPE"] = 2] = "INTERACT_SET_ALL_FOR_TYPE";
    StoreAction[StoreAction["INTERACT_UPDATE_SPECIFIC"] = 3] = "INTERACT_UPDATE_SPECIFIC";
    StoreAction[StoreAction["PAYMENT_UPDATE_FINANCING_INFORMATION"] = 4] = "PAYMENT_UPDATE_FINANCING_INFORMATION";
})(StoreAction || (StoreAction = {}));
export default StoreAction;
